import { render, staticRenderFns } from "./picture_page.vue?vue&type=template&id=c6df4de4&scoped=true"
import script from "./picture_page.vue?vue&type=script&lang=js"
export * from "./picture_page.vue?vue&type=script&lang=js"
import style0 from "./picture_page.vue?vue&type=style&index=0&id=c6df4de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6df4de4",
  null
  
)

export default component.exports